<template>
  <section>
    <b-modal width="680px" :active.sync="isAlertModalActive" :can-cancel="false">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <!-- タイトル -->
          <p class="card-header-title">
            {{getTitle}}
          </p>
        </header>
        <!-- メッセージ -->
        <div class="card-content">
          <p>
            <!-- 警告メッセージ -->
            <b-message type="is-warning" has-icon v-if="getAlertMessateType === this.messageWarning">
              <p v-html="getAlertMessage"></p>
            </b-message>
            <!-- 情報メッセージ -->
            <b-message type="is-info" has-icon v-else-if="getAlertMessateType === this.messageInfo">
              <p v-html="getAlertMessage"></p>
            </b-message>
            <!-- 完了メッセージ -->
            <b-message type="is-success" has-icon v-else-if="getAlertMessateType === this.messageSuccess">
              <p v-html="getAlertMessage"></p>
            </b-message>
            <!-- 危険メッセージ -->
            <b-message type="is-danger" has-icon v-else-if="getAlertMessateType === this.messageDanger">
              <p v-html="getAlertMessage"></p>
            </b-message>
            <!-- 通常メッセージ -->
            <b-message v-else>
              <p v-html="getAlertMessage"></p>
            </b-message>
          </p>
        </div>
        <div v-show="getAlertDialogType !== this.dialogToast">
          <!-- 確認ダイアログ用 -->
          <footer class="card-footer" v-if="getAlertDialogType === this.dialogConfirm">
            <a class="card-footer-item" @click="resultBuuton(resultNo)">いいえ</a>
            <a class="card-footer-item" @click="resultBuuton(resultYes)">はい</a>
          </footer>
          <!-- OK／Cancelダイアログ用 -->
          <footer class="card-footer" v-else-if="getAlertDialogType === this.dialogOkCancel">
            <a class="card-footer-item" @click="resultBuuton(resultOk)">OK</a>
            <a class="card-footer-item" @click="resultBuuton(resultCancel)">キャンセル</a>
          </footer>
          <!-- マルチボタンダイアログ用 -->
          <footer class="card-footer" v-else-if="getAlertDialogType === this.dialogMultiple">
            <a class="card-footer-item" @click="resultBuuton(value)" v-for="(value, key) in getAlertMultipleButton" :key='key'>{{key}}</a>
          </footer>
          <!-- アラートダイアログ用 -->
          <footer class="card-footer" v-else>
            <a class="card-footer-item" @click="resultBuuton(resultOk)">OK</a>
          </footer>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import {
  ALERT_DEF        // アラートダイアログ用定義
} from '@/functions/common/alertFunc'

export default {
  name: 'ModalAlertDialog',
  componentName: 'ModalAlertDialog',
  computed: {
    /** タイトル取得 */
    getTitle () {
      // 改行削除
      if (this.alertData.alertTitle) {
        return this.alertData.alertTitle.replace(/\r?\n/g, ' ')
      } else {
        return ''
      }
    },
    /** メッセージ取得 */
    getAlertMessage () {
      // 改行を置換
      if (this.alertData.alertMessage) {
        return this.$sanitize(this.alertData.alertMessage.replace(/\r?\n/g, '<br/>'))
      } else {
        return ''
      }
    },
    /** メッセージ種別取得 */
    getAlertMessateType () {
      if (this.alertData.alertMessageType) {
        return this.alertData.alertMessageType
      } else {
        return this.messageDefault
      }
    },
    /** ダイアログ種別取得 */
    getAlertDialogType () {
      if (this.alertData.alertDialogType) {
        return this.alertData.alertDialogType
      } else {
        return this.dialogToast
      }
    },
    /** マルチボタン取得  */
    getAlertMultipleButton () {
      if (this.alertData.alertMultipleButton) {
        return this.alertData.alertMultipleButton
      } else {
        return {}
      }
    }
  },
  data () {
    return {
      /** モーダルダイアログ開閉フラグ */
      isAlertModalActive: this.isAlertDialogOpen,
      /** ワーニングメッセージ */
      messageWarning    : ALERT_DEF.MESSAGE_WARNING,
      /** インフォメーションメッセージ */
      messageInfo       : ALERT_DEF.MESSAGE_INFO,
      /** 正常終了メッセージ */
      messageSuccess    : ALERT_DEF.MESSAGE_SUCCESS,
      /** 危険メッセージ */
      messageDanger     : ALERT_DEF.MESSAGE_DANGER,
      /** 標準メッセージ */
      messageDefault    : ALERT_DEF.MESSAGE_DEFAULT,
      /** トースト */
      dialogToast       : ALERT_DEF.DIALOG_TOAST,
      /** 確認ダイアログ */
      dialogConfirm     : ALERT_DEF.DIALOG_CONFIRM,
      /** OK/Canceダイアログ */
      dialogOkCancel    : ALERT_DEF.DIALOG_OK_CANCEL,
      /** マルチボタンダイアログ */
      dialogMultiple    : ALERT_DEF.DIALOG_MULRIPLE,
      /** アラートダイアログ */
      dialogAlert       : ALERT_DEF.DIALOG_ALERT,
      /** はいボタン押下 */
      resultYes         : ALERT_DEF.RESULT_YES,
      /** いいえボタン押下 */
      resultNo          : ALERT_DEF.RESULT_NO,
      /** OKボタン押下 */
      resultOk          : ALERT_DEF.RESULT_OK,
      /** キャンセルボタン押下 */
      resultCancel      : ALERT_DEF.RESULT_CANCEL,
      /** トースト表示時間(ms) */
      toastDispTime     : ALERT_DEF.TOAST_DISP_TIME
    }
  },
  props: {
    /** モーダルダイアログ開閉フラグ */
    isAlertDialogOpen: {
      type    : Boolean,
      default : false,
      required: true
    },
    /** ダイアログ表示情報 */
    alertData: {
      required: true
    },
    functionNmae: {
      required: false
    }
  },
  watch: {
    /** モーダルダイアログ開閉フラグ */
    isAlertDialogOpen () {
      this.isAlertModalActive = this.isAlertDialogOpen
      if (this.isAlertDialogOpen && this.alertData.alertDialogType === ALERT_DEF.DIALOG_TOAST) {
        // トーストの場合、指定時間後にクローズ
        setTimeout(this.resultBuuton(this.resultOk), this.alertData.alertToastTime ? Number(this.alertData.alertToastTime) : ALERT_DEF.TOAST_DISP_TIME)
      }
    }
  },
  methods: {
    /** ボタン押下 */
    resultBuuton (value) {
      const result = {
        // 戻り値判定機能名
        alertKeyFunction: this.alertData.alertKeyFunction,
        // 戻り値判定キーワード
        alertKeyWord    : this.alertData.alertKeyWord,
        // 戻り値
        alertResultValue: value
      }
      this.$emit('alertResult', result)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/common/ModalAlertDialog.vue